import { render } from "./Show.vue?vue&type=template&id=7cf43408"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/byte-dev.it/carma.byte-dev.it/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__